// extracted by mini-css-extract-plugin
module.exports = {"mobile":"screen and (max-width: 600px)","container":"_3SRG2GV1jxD6","refuse":"_2z_Qx_qLXKlP","button":"_1w49wo0LJu3e","text":"s9tYrJxicUlY"};